module.exports = __webpack_public_path__ + "img/qualityIndexScore5.2463cac0.png";